import * as t from 'io-ts';
import {
  Template,
  RouteInfo,
  CabTypesAvailableForRent,
  CarTypeInfoDataChecker,
  NameUrl,
  RouteCarTypeInfo,
  InterlinkBlockDataChecker,
  AggregateRating
} from '../../../src/pages/runtime-typechecker';

export const CityData = t.type({
  id: t.number,
  name: t.string,
  description: t.string,
  latitude: t.union([t.string, t.null, t.number]),
  longitude: t.union([t.string, t.null, t.number]),
  code: t.string,
  placeId: t.string,
  description2HTML: t.union([t.null, t.undefined, t.string]),
  cabTypesAvailableForRent: CabTypesAvailableForRent,
  cabModelsAvailableForRent: CabTypesAvailableForRent,
  carTypeInfo: t.union([t.undefined, CarTypeInfoDataChecker])
});

export const CityHRTemplateChecker = t.type({
  id: t.number,
  isActive: t.boolean,
  url: t.string,
  description: t.union([t.string, t.null]),
  descriptionInHtml: t.union([t.string, t.null]),
  htmlRefreshDate: t.union([t.string, t.null]),
  created: t.string,
  modified: t.string,
  templateData: Template,
  cityData: CityData,
  hourlyRentalUrlsInOtherCities: t.union([t.array(NameUrl), t.undefined]),
  randomPopularCities: t.union([t.array(NameUrl), t.undefined]),
  randomPopularRoutes: t.union([t.array(RouteInfo), t.undefined]),
  routesFromSource: t.union([t.array(RouteInfo), t.undefined]),
  routeCarTypesFromSource: t.union([t.array(RouteCarTypeInfo), t.undefined]),
  routeCarTypesToSource: t.union([t.array(RouteCarTypeInfo), t.undefined]),
  hrPackages: t.union([t.undefined, t.array(t.string)]),
  interlinks: t.union([t.undefined, t.array(InterlinkBlockDataChecker)]),
  aggregateRating: AggregateRating,
  schemaMinFare: t.number
});

export type CityHRTemplateData = t.TypeOf<typeof CityHRTemplateChecker>;
